/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceExtendedDto } from '../../models/case-resource-extended-dto';

export interface GetAllExtendedCaseResourcesByAdId$Params {
  adId: string;
}

export function getAllExtendedCaseResourcesByAdId(http: HttpClient, rootUrl: string, params: GetAllExtendedCaseResourcesByAdId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CaseResourceExtendedDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllExtendedCaseResourcesByAdId.PATH, 'get');
  if (params) {
    rb.query('adId', params.adId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CaseResourceExtendedDto>>;
    })
  );
}

getAllExtendedCaseResourcesByAdId.PATH = '/case-resources/ad/extended/list';
